import { useUser } from "context";
import { useTeamCredits } from "./useTeamCredits";

export const useCurrentTeamCredits = () => {
  const [{ currentTeam }] = useUser();
  return useTeamCredits(currentTeam?.id || 0, {
    query: {
      enabled: !!currentTeam?.id,
    },
  });
};
